<app-dialog-header *ngIf="this.dataDialog.isDialog" label="Tipus de matrícules" i18n-label></app-dialog-header>
<app-toolbar>
  <app-tool-button text="Nou" i18n-text (click)="create();" color="has-color-green" icon="fa-plus-square" [disabled]="!this.auth.UserCanCreate(this.auth.Pages.TipusMatricules)"></app-tool-button>
  <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
  <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button>
  <app-tool-button text="Excel" i18n-text (click)="generateExcel();" color="has-color-darkgreen" icon="fa-file-excel"></app-tool-button>
  <app-tool-button-permissions [permission]="this.auth.Pages.TipusMatricules"></app-tool-button-permissions>
  <app-tool-button text="Matrícules" i18n-text (click)="viewMatricules();" color="has-color-yellow" icon="fa-th-list"></app-tool-button>
</app-toolbar>

<app-tipus-matricules-table [updatedFilterData]="filterData" (notify)="onRowSelected($event)"></app-tipus-matricules-table>

